import type { ProjectFileResponseDto } from '@inference.engine/workspace-api-client/web';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { PROJECTS_QUERY_KEYS } from '@/entities/project';
import { PROJECT_TAG_QUERY_KEYS } from '@/entities/project-tag';
import { updateProjectFile } from './project-files.api';

interface UseUpdateProjectFileTagsOptions {
  projectId: string;
}

interface UpdateTagsVariables {
  fileId: string;
  tags: string[];
}

export function useUpdateProjectFileTags(options: UseUpdateProjectFileTagsOptions) {
  const queryClient = useQueryClient();
  const { projectId } = options;

  return useMutation<ProjectFileResponseDto, Error, UpdateTagsVariables>({
    mutationFn: ({ fileId, tags }) => updateProjectFile(projectId, fileId, { tags }),
    onSuccess: (_file, { fileId }) => {
      void queryClient.invalidateQueries({
        queryKey: PROJECTS_QUERY_KEYS.files.detail(projectId, fileId),
      });
      // Folder file listings render cards with tag badges, so they need to refresh.
      void queryClient.invalidateQueries({ queryKey: ['project', projectId, 'folders'] });
      // Names may have been minted server-side via findOrCreateByNames; refresh
      // the workspace-wide tag pool so suggestions stay current.
      void queryClient.invalidateQueries({ queryKey: PROJECT_TAG_QUERY_KEYS.all });
    },
  });
}
